import DOMPurify from 'dompurify';

// checks if the html is correct and save
export default function checkHtml(html: string): { __html: string } {
    // do NOT allow script tags in html
    if (html.includes('<script>')) return { __html: '' };

    return { __html: DOMPurify.sanitize(html) };
}
